import { useState } from 'react';
import {
    InputText as PrimeReactInputText,
    InputTextProps as PrimeReactInputTextProps,
} from 'primereact/inputtext';

import './style.css';
import renderIsRequired from '../utils/renderIsRequired';

export interface IInputText extends PrimeReactInputTextProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    error?: string | null;
    value?: string;
    validations?: {
        validate: (value: string | undefined) => boolean;
        validationError?: string;
    }[];
    validationCallback?(isValid: boolean, error: string | null): void;
    required?: boolean;
    wrapperStyle?: React.CSSProperties;
}

export const InputText: React.FC<IInputText> = ({
    label,
    name,
    labelStyle,
    error,
    validations,
    validationCallback,
    required,
    ...rest
}) => {
    const [validationError, setValidationError] = useState<string | null>(null);

    const validate = (value?: string) => {
        if (!validations) return true;
        const notValid = validations.find((v) => {
            return !v.validate(value);
        });
        const errorMessage = notValid
            ? notValid.validationError ?? 'Validation error'
            : null;
        if (errorMessage) {
            setValidationError(errorMessage);
        } else setValidationError(null);
        if (validationCallback) validationCallback(!notValid, errorMessage);
    };

    return (
        <div className='custom-input-text' style={rest.wrapperStyle}>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display: label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                    {renderIsRequired(required)}
                </label>
                <PrimeReactInputText
                    {...rest}
                    onChange={(e) => {
                        validate(e.target.value);
                        if (rest.onChange) rest.onChange(e);
                    }}
                    className={
                        rest.className +
                        (validationError || error ? '  p-invalid' : '')
                    }
                />
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-text-error'
                    >
                        {error}
                    </small>
                )}
                {validationError && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-text-error'
                    >
                        {validationError}
                    </small>
                )}
            </span>
        </div>
    );
};
